
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.04 2c.53 0 .96.43.96.96v10.757H7.208a.404.404 0 000 .808H23v1.616H7.208a.404.404 0 000 .808H23v1.617H7.208a.404.404 0 100 .808H23v.706c0 1.06-.86 1.92-1.92 1.92H2.92A1.92 1.92 0 011 20.08V5.384c0-.53.43-.96.96-.96h1.075v14.992a.49.49 0 10.981 0V2.96c0-.53.43-.96.96-.96H22.04zm-9.42 2.876H7.295a.48.48 0 00-.48.48v5.504c0 .266.215.48.48.48h5.325a.48.48 0 00.48-.48V5.356a.48.48 0 00-.48-.48z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    